import { render, staticRenderFns } from "./ClientGroupView.vue?vue&type=template&id=15879df2&scoped=true&"
import script from "./ClientGroupView.vue?vue&type=script&lang=js&"
export * from "./ClientGroupView.vue?vue&type=script&lang=js&"
import style0 from "./ClientGroupView.vue?vue&type=style&index=0&id=15879df2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15879df2",
  null
  
)

export default component.exports